import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const PageBanner = ({ title, breadcrumbs = [] }) => {
  return (
    <div className="relative bg-primary py-20 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4">
          {title}
        </h1>
        
        {/* Breadcrumbs */}
        <nav className="flex justify-center items-center gap-2 text-white/80">
          <Link to="/" className="flex items-center gap-1 hover:text-white transition-colors" data-testid="breadcrumb-home">
            <Home className="w-4 h-4" />
            <span>Home</span>
          </Link>
          {breadcrumbs.map((crumb, index) => (
            <div key={index} className="flex items-center gap-2">
              <ChevronRight className="w-4 h-4" />
              {crumb.path ? (
                <Link to={crumb.path} className="hover:text-white transition-colors" data-testid={`breadcrumb-${crumb.label.toLowerCase()}`}>
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-white">{crumb.label}</span>
              )}
            </div>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default PageBanner;
